<script>
import RepeatableElementCard from "@core/components/common/RepeatableElementCard.vue";
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {RepeatableElementCard, BFormGroup, BFormInput},
    props: {
        domains: {
            default() {
                return [];
            }
        }
    }
}
</script>

<template>
    <RepeatableElementCard
        :elements="domains"
        :title="$t('Component(CardLabel):domains')"
        @add="$emit('add')"
        @remove="(params) => $emit('remove', params)"
    >
        <template #default="data">
            <b-form-group
                :label="$t('Component(Label):domain')"
            >
                <b-form-input
                    v-model="data.item"
                    @input="$emit('change', data)"
                    :placeholder="$t('Component(Placeholder):domain')"
                />
            </b-form-group>
        </template>
    </RepeatableElementCard>
</template>
